import styled from 'styled-components';
import Container from '@grnhse/seedling/lib/birch/components/container';

export const MAX_WIDTH = '1640px';

export const StyledContainer = styled(Container)`
  padding: 24px;
`;

export const ButtonWrapper = styled.div`
  margin-left: -6px;
`;
